/*
 * Author: Dw
 * File Created: Monday, 24-08-05 02:04 pm
 * Last Modified: Friday, 25-04-25 11:29 am, by Ben Zhao
 */

import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Grid, Typography } from '@mui/material';
import { regex } from '@web/utils';
import { followedUser } from '@/services/account/service';
import GoInput from '../GolInput';
import DecardIcon from './_components/DecardIcon';
import FooterIcon from './_components/icons';
import { socialIcons } from './config';
import { AboutUsBox, LabelText, SocialIconBox } from './style';
interface FooterProps {
  vip: boolean;
}
const PcFooter: React.FC<FooterProps> = ({
  vip: isVip
}) => {
  const {
    t
  } = useTranslation('common');
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const onSubmit = async () => {
    if (loading) return;
    if (regex.email.test(email)) {
      try {
        setLoading(true);
        await followedUser({
          email
        });
        setError(t('landing-footer.text.helpertext'));
      } finally {
        setLoading(false);
      }
    }
  };
  const handleChange = (value: string) => {
    setEmail(value);
  };
  return <Grid container data-sentry-element="Grid" data-sentry-component="PcFooter" data-sentry-source-file="PcFooter.tsx">
      <Grid item xs={2} data-sentry-element="Grid" data-sentry-source-file="PcFooter.tsx">
        <DecardIcon sx={{
        width: '103px',
        height: '72px'
      }} data-sentry-element="DecardIcon" data-sentry-source-file="PcFooter.tsx" />
      </Grid>
      <Grid item xs={6} data-sentry-element="Grid" data-sentry-source-file="PcFooter.tsx">
        <AboutUsBox data-sentry-element="AboutUsBox" data-sentry-source-file="PcFooter.tsx">
          <Typography variant="h5" data-sentry-element="Typography" data-sentry-source-file="PcFooter.tsx">
            {t('landing-footer.about-us.title')}
          </Typography>
          <Typography mt={1.5} variant="body1" data-sentry-element="Typography" data-sentry-source-file="PcFooter.tsx">
            {t('landing-footer.about-us.content.0')}
          </Typography>
          <Typography mt={2} variant="body1" data-sentry-element="Typography" data-sentry-source-file="PcFooter.tsx">
            {t('landing-footer.about-us.content.1')}
          </Typography>
          <Typography mt={2} variant="body1" data-sentry-element="Typography" data-sentry-source-file="PcFooter.tsx">
            {t('landing-footer.about-us.content.2')}
          </Typography>
          <Typography mt={2} variant="body1" data-sentry-element="Typography" data-sentry-source-file="PcFooter.tsx">
            {t('landing-footer.about-us.content.3')}
          </Typography>
        </AboutUsBox>
      </Grid>
      <Grid item xs={1} data-sentry-element="Grid" data-sentry-source-file="PcFooter.tsx" />
      <Grid item xs={3} data-sentry-element="Grid" data-sentry-source-file="PcFooter.tsx">
        <LabelText data-sentry-element="LabelText" data-sentry-source-file="PcFooter.tsx">{t('landing-footer.text.follow')}</LabelText>
        <SocialIconBox data-sentry-element="SocialIconBox" data-sentry-source-file="PcFooter.tsx">
          {socialIcons.map((item, index) => <FooterIcon key={index} name={item.iconName} onClick={() => {
          window.open(item.url, '_blank');
        }} />)}
        </SocialIconBox>
        <LabelText mb={1} mt={3.5} data-sentry-element="LabelText" data-sentry-source-file="PcFooter.tsx">
          {t('landing-footer.text.signup')}
        </LabelText>
        <GoInput buttonColor={isVip ? 'vip' : 'main'} error={Boolean(error)} helperText={error} onChange={handleChange} onSubmit={onSubmit} placeholder={t('landing-footer.text.email-placeholder')} type="email" data-sentry-element="GoInput" data-sentry-source-file="PcFooter.tsx" />
      </Grid>
    </Grid>;
};
export default PcFooter;